<template>
    <div class="basic">
        <el-row :gutter="24" class="basic-row">
            <!-- 左侧：基本信息 + 调查信息 + 案件笔录信息 + 已生效文书 -->
            <el-col :span="16">
                <div class="basic-left">
                    <!-- 案件基本信息 -->
                    <div class="section-block">
                        <div class="section-title">案件信息</div>
                        <el-descriptions class="section-descriptions margin-top" :column="3" border>
                            <el-descriptions-item label="案件编号">{{investigData.caseCode || '-'}}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                  <div class="section-block">
                    <div class="section-title">伤者信息</div>
                    <el-descriptions class="section-descriptions margin-top" :column="2" border>
                      <el-descriptions-item label="伤者姓名">{{investigData.woundedName || '-'}}</el-descriptions-item>
                      <el-descriptions-item label="身份证号">{{investigData.woundedIdNumber || '-'}}</el-descriptions-item>
                      <el-descriptions-item label="联系电话">{{investigData.woundedPhone || '-'}}</el-descriptions-item>
                      <el-descriptions-item label="联系地址">{{investigData.woundedAddress || '-'}}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                  <div class="section-block">
                    <div class="section-title">事故信息</div>
                    <el-descriptions class="section-descriptions margin-top" :column="2" border>
                      <el-descriptions-item label="伤害类型">{{investigData.accidentHarmTypeName || '-'}}</el-descriptions-item>
                      <el-descriptions-item label="事故日期">{{investigData.accidentDate || '-'}}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                    <div class="section-block">
                        <div class="section-title">申请人信息</div>
                        <el-descriptions class="section-descriptions margin-top" :column="3" border>
                            <el-descriptions-item label="申请人类型">{{investigData.proposerTypeName || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="申请人">{{investigData.proposerName || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="申请方式">{{investigData.proposerModeName || '-'}}</el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div class="section-block">
                        <div class="section-title">单位信息</div>
                        <el-descriptions class="section-descriptions margin-top" :column="2" border>
                            <el-descriptions-item label="用人单位">{{investigData.unitName || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="企业信用代码">{{investigData.unitCreditCode || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="单位联系地址">{{investigData.unitAddress || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="单位联系电话">{{investigData.unitPhone || '-'}}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                  <div class="section-block">
                        <div class="section-title">委托人信息</div>
                        <el-descriptions class="section-descriptions margin-top" :column="2" border>
                            <el-descriptions-item label="被委托人">{{investigData.unitConsignorName || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="被委托人身份证">{{investigData.unitConsignorIdNumber || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="委托人手机号码">{{investigData.unitConsignorPhone || '-'}}</el-descriptions-item>
                            <el-descriptions-item label="申请日期">{{investigData.applyDate || '-'}}</el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div class="section-block">
                        <div class="section-title">受理审核信息</div>
                        <el-descriptions class="section-descriptions margin-top" :column="2" border>
                            <el-descriptions-item label="审核意见">予以受理</el-descriptions-item>
                            <el-descriptions-item label="受理日期">{{investigData.acceptData || '-'}}</el-descriptions-item>
<!--                            <el-descriptions-item label="不予受理日期">-</el-descriptions-item>-->
                            <el-descriptions-item label="受理人">{{investigData.acceptUserName || '-'}}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <!-- 调查信息（只读展示，在「调查信息」Tab 填写并保存后在此展示） -->
                    <div class="section-block">
                        <div class="section-title">案件调查信息</div>
                        <template v-if="hasInvestigData">
                            <el-descriptions class="section-descriptions margin-top" :column="3" border>
                                <el-descriptions-item label="案件分类">{{ investigData.caseTypeName || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="承办人">{{ investigData.undertakerName || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="参保情况">{{ investigData.insuredConditionName || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="与关联单位关系">{{ investigData.unitRelationName || '-' }}</el-descriptions-item>
                                <el-descriptions-item v-if="investigData.unitRelationCode==2 || investigData.unitRelationCode==3 || investigData.unitRelationCode==5" label="关联单位">{{ investigData.unitName || '-' }}</el-descriptions-item>
                                <el-descriptions-item v-if="investigData.unitRelationCode==4" label="项目名称">{{ investigData.projectName || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="中止原因">{{ investigData.suspendCauseName || '-' }}</el-descriptions-item>
                                <el-descriptions-item  label="中止日期" v-if="investigData.suspendCauseCode>0">{{ investigData.suspendDate || '-' }}</el-descriptions-item>
                                <el-descriptions-item  label="恢复日期" v-if="investigData.suspendCauseCode>0">{{ investigData.suspendRecoverDate || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="是否属于安全生产事故">{{ investigData.isWorkSafetyAccident==1?'是':'否' }}</el-descriptions-item>
                                <el-descriptions-item label="是否认定为工伤">{{ investigData.certificationDate || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="事故前3周医保查询情况" :span="5">{{ investigData.medicalInsuranceSituation || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="事故前3周就诊记录" :span="5">{{ investigData.medicalRecord || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="劳动关系说明" :span="5">{{ investigData.laborRelationExplain || '-' }}</el-descriptions-item>
                                <el-descriptions-item label="参保情况说明" :span="5">{{ investigData.insuranceParticipationExplain || '-' }}</el-descriptions-item>
                            </el-descriptions>
                        </template>
                        <template v-else>
                            <div class="investig-empty">暂无调查信息，请至「调查信息」填写并保存</div>
                        </template>
                    </div>

                    <!-- 案件笔录信息 -->
                    <TranscriptRecordList />
                    <!-- 已生效文书 -->
                    <EffectiveDocList />
                </div>
            </el-col>
            <!-- 右侧：补材通知记录时间轴 -->
            <el-col :span="8">
                <SupplementRecordTimeline />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getListByDictType } from '@/api/sys/dictData'
import SupplementRecordTimeline from './SupplementRecordTimeline.vue'
import TranscriptRecordList from './TranscriptRecordList.vue'
import EffectiveDocList from './EffectiveDocList.vue'
import {getSurveyDetail,getSurveyInfo} from '@/api/recognition/survey'
export default {
    name: 'basic',
    components: {
        SupplementRecordTimeline,
        TranscriptRecordList,
        EffectiveDocList
    },
    props: {

    },
    data() {
        return {
            caseClassificationOptions: [],
            insuranceStatusOptions: [],
            relationWithUnitOptions: [],
            suspensionReasonOptions: [],
            investigData: {}
        }
    },
    computed: {
        hasInvestigData() {
            const d = this.investigData
            return d && typeof d === 'object' && Object.keys(d).length > 0
        },
        showAssociatedUnit() {
            const v = String((this.investigData || {}).relationWithUnit ?? '')
            return ['2', '4', '5'].includes(v)
        },
        showProjectName() {
            return String((this.investigData || {}).relationWithUnit ?? '') === '3'
        },
        isSuspensionReasonNone() {
            const v = (this.investigData || {}).suspensionReason
            if (v === '' || v == null) return true
            const opt = (this.suspensionReasonOptions || []).find(
                (item) => String(item.dictValue) === String(v)
            )
            if (opt) return (opt.dictLabel || '').trim() === '无'
            return String(v) === '0'
        },
        showSuspensionDates() {
            return this.hasInvestigData && !this.isSuspensionReasonNone
        }
    },
    created() {
        this.loadDictData();
        this.getDetail()
    },
    methods: {
        getDictLabel(options, value) {
            if (value === undefined || value === null || value === '') return '-'
            const opt = (options || []).find((item) => String(item.dictValue) === String(value))
            return opt ? (opt.dictLabel || '-') : value
        },
        async loadDictData() {
            const dictTypes = [
                { key: 'caseClassificationOptions', type: 'industrial_injury_case_classification' },
                { key: 'insuranceStatusOptions', type: 'industrial_injury_insurance_status' },
                { key: 'relationWithUnitOptions', type: 'industrial_injury_relation_with_unit' },
                { key: 'suspensionReasonOptions', type: 'industrial_injury_suspension_reason' }
            ]
            for (const { key, type } of dictTypes) {
                try {
                    const res = await getListByDictType(type)
                    if (res && res.code === 200 && res.data) {
                        this[key] = res.data
                    }
                } catch (e) {
                    console.warn(`字典 ${type} 加载失败`, e)
                }
            }
        },
    //   获取详情
        async getDetail() {
          let id=this.$route.query.id
          if(id){
            const res = await getSurveyDetail({ id: id })
            const res2 = await getSurveyInfo({ caseId: id })
            if (res && res.code === 200 && res.data) {
              this.investigData = res.data;
              this.$emit('step1info',res.data)
            }
            if (res2 && res2.code === 200 && res2.data) {
              this.investigData = {...res2.data,...this.investigData}
              this.$emit('step2Status',res2.data.status)
            }
          }
        }
    }
}
</script>

<style lang="scss" scoped>
.basic {
    width: 100%;
    height: 100%;
}

.basic-row {
    height: 100%;
}

.basic-left {
    padding-right: 0;
}

.section-block {
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
}

.section-title {
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding-left: 11px;
    margin-bottom: 12px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 12px;
        border-radius: 20px;
        background: var(--vt-c-blue);
    }
}

.section-descriptions {
    :deep(.el-descriptions__label) {
        font-weight: 500;
        color: #606266;
        background-color: #fafafa;
    }

    :deep(.el-descriptions__content) {
        color: #303133;
        background-color: #fff;
    }

    :deep(.el-descriptions__body .el-descriptions__table tr:nth-child(even) .el-descriptions__cell) {
        background-color: #f5f7fa;
    }

    :deep(.el-descriptions__body .el-descriptions__table tr:nth-child(odd) .el-descriptions__cell) {
        background-color: #fff;
    }
}

.investig-empty {
    color: #909399;
    font-size: 14px;
    padding: 16px 0;
}

.margin-top {
    margin-top: 0;
}
</style>
